import React from "react";
import { Fstyr } from "../../components/FstyrComponents/Fstyr.js";
import { fetchModel } from "../../components/HelperComponents/FetchExtension";
import URL from "../../Constants/URL";
import { ControlCardVm } from "../../Models/ControlCardVm";
import { sortCardTableByDate } from "../../components/HelperComponents/Helpers";
import { AuthorityVm } from "../../Models/AuthorityVm";
import { Link } from "react-router-dom";
import { DateFormatter } from "../../components/HelperComponents/DateFormatter";
import { GetStatusName } from "../../components/HelperComponents/StatusHelper";

type Props = {};

type State = {
  authorities: AuthorityVm[];

  // input
  authInput: string;
  authority: AuthorityVm | null;
  searchButtonPressed: boolean;

  showSpinner: boolean;

  tableResults: (JSX.Element | string)[][];
};

export class SearchControlAuthority extends React.Component<Props, State> {
  private toastRef: React.RefObject<any>;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      authorities: [],

      // input
      authInput: "",
      authority: null,
      searchButtonPressed: false,

      showSpinner: false,

      tableResults: [],
    };
  }

  componentDidMount() {
    this.getAuthorities();
  }

  getAuthorities() {
    fetchModel("GET", URL + "/api/search/GetActiveAuthsAndAuthsWithActiveControlCards", "", AuthorityVm).then((model) => {
      this.setState({ authorities: model });
    });
  }

  setAuthority(auth: string) {
    this.clearPage(false);
    var authority = this.state.authorities.find((a) => auth.includes(a.AuthorityCode)) ?? null;
    this.setState({ authInput: auth, authority: authority });
  }

  handleSearch() {
    this.setState({ searchButtonPressed: true }, () => this.clearPage(false));
    if (this.state.authority) {
      this.setState({ showSpinner: true });
      this.fetchControlCards();
    }
  }

  fetchControlCards() {
    if (this.state.authority?.AuthorityCode)
      fetchModel("GET", URL + "/api/controlcard/GetControlCardsByPoliceAuthNr", this.state.authority?.AuthorityCode, ControlCardVm)
        .then((model) => {
          this.handleControlCardSearchResults(model);
        })
        .catch((error) => this.showErrorToast(error, "et kontrolkort"))
        .finally(() => {
          this.setState({ showSpinner: false });
        });
  }

  handleControlCardSearchResults(result: ControlCardVm[]) {
    result = sortCardTableByDate(result);
    this.setState({
      tableResults: result.map((controlCard) => [
        <Link target="_blank" to={`/controlcard/searchControlG2V2/${controlCard.CardNumber}`}>
          {controlCard.CardNumber}
        </Link>,
        controlCard.Officer.WrxNummer,
        DateFormatter(controlCard.ValidFrom),
        DateFormatter(controlCard.ValidTo),
        GetStatusName(controlCard.Status.Id),
      ]),
    });
  }

  clearPage(clearInput: boolean) {
    this.setState({
      showSpinner: false,
      tableResults: [],
    });

    if (clearInput) {
      this.setState({
        authInput: "",
        authority: null,
      });
    }
  }

  showErrorToast(error: string, msg: string) {
    this.setState({ showSpinner: false });
    if (error === "No result") {
      this.toastRef.current.show("Virksomhed", `Der findes ikke ${msg} med det søgte nummer`, "warning");
    } else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error");
    } else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error");
    }
  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment title="Søg Kontrolkort" isPageTitle={true}>
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button label="Ryd side" onClick={() => this.clearPage(true)} />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title={`Angiv Myndighedskode`}>
          <div className={this.state.searchButtonPressed && !this.state.authority ? "form-group form-error" : ""}>
            <Fstyr.Dropdown label="Vælg myndighed" items={this.state.authorities.map((auth) => `${auth.PlaceOfIssue} (${auth.AuthorityCode})`)} width={300} onItemSelected={(item: string) => this.setAuthority(item)} initialValue={this.state.authInput} autocomplete />
            {this.state.searchButtonPressed && !this.state.authority && (
              <span className="form-error-message" id="form-error-error">
                {"Myndighed mangler."}
              </span>
            )}
          </div>

          <div className="fstyr-left-button-group">
            <Fstyr.Button label="Søg" onClick={() => this.handleSearch()} disabled={this.state.showSpinner} />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner show={this.state.showSpinner} />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment isPageTitle={true}>
          <Fstyr.Table label="Registreret kontrolkort" headers={["Kortnr.", "ID-nummer", "Startdato", "Udløbsdato", "Status"]} data={this.state.tableResults} note={`Myndighed har ${this.state.tableResults.length} registrering${this.state.tableResults.length === 1 ? "" : "er"} på kontrolkort`} />
        </Fstyr.Segment>
      </>
    );
  }
}
